<template>
  <div class="app-inputs">
    <slot/>
  </div>
</template>

<script>
export default {
  methods: {

    getValues() {
      const values = {};
      this.$children.forEach((el, i) => {
        if (Object.prototype.hasOwnProperty.call(el, 'getValue')) {
          if (typeof el.options.name !== 'undefined') {
            values[el.options.name] = el.getValue();
          } else {
            values[i] = el.getValue();
          }
        }
      });
      return values;
    },

    clearValues() {
      this.$children.forEach((el) => {
        if (Object.prototype.hasOwnProperty.call(el, 'clearValue')) {
          el.clearValue();
        }
      });
    },

    getErrors() {
      const errors = {};
      this.$children.forEach((el, i) => {
        if (Object.prototype.hasOwnProperty.call(el, 'getError')) {
          if (el.options.name) {
            errors[el.options.name] = el.getError();
          } else {
            errors[i] = el.getError();
          }
        }
      });
      return errors;
    },

    hasErrors() {
      const errors = this.getErrors();
      let hasErrors = false;
      Object.keys(errors).forEach((fieldName) => {
        errors[fieldName].forEach((fieldError) => {
          if (hasErrors) return;
          if (typeof fieldError === 'object') {
            // If field error is object
            Object.keys(fieldError).forEach((fieldField) => {
              if (hasErrors) return;
              hasErrors = (fieldError[fieldField] !== '');
            });
          } else {
            // If field error is string
            hasErrors = (fieldError !== '');
          }
        });
      });
      return hasErrors;
    },

  },
};
</script>



// WEBPACK FOOTER //
// src/components/inputs/AppInputs.vue